import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  AuthPartialState,
  AuthFacade as CignaAuthFacade,
} from '@cigna/shared/angular/auth-data-access';
import * as AuthstateSelectors from './authstate.selectors';

@Injectable({
  providedIn: 'root',
})
export class AuthFacade {
  useremail$ = this.store$.pipe(
    select(AuthstateSelectors.authQuery.getUseremail),
  );

  getAccessToken$ = this.store$.pipe(
    select(AuthstateSelectors.authQuery.getAccessToken),
  );

  constructor(
    private store$: Store<AuthPartialState>,
    _cignaAuthFacade: CignaAuthFacade,
  ) {}
}
